import React from 'react';
import LogToolbar from './LogToolbar';

export default function LogClicksToolbar(props) {
    return <LogToolbar {...props} kind="clicks"/>;
}
